module.exports = __webpack_public_path__ + "static/media/exclamationMark.092387d5.svg";